var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePlus02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.138 6.99967V4.53301C14.138 3.4129 14.138 2.85285 13.9201 2.42503C13.7283 2.0487 13.4223 1.74274 13.046 1.55099C12.6182 1.33301 12.0581 1.33301 10.938 1.33301H6.67137C5.55127 1.33301 4.99122 1.33301 4.56339 1.55099C4.18707 1.74274 3.88111 2.0487 3.68936 2.42503C3.47137 2.85285 3.47137 3.4129 3.47137 4.53301V11.4663C3.47137 12.5864 3.47137 13.1465 3.68936 13.5743C3.88111 13.9506 4.18707 14.2566 4.56339 14.4484C4.99122 14.6663 5.55127 14.6663 6.67137 14.6663H8.80471M10.138 7.33301H6.13804M7.47137 9.99967H6.13804M11.4714 4.66634H6.13804M12.8047 13.9997V9.99967M10.8047 11.9997H14.8047",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePlus02);
export default __webpack_public_path__ + "static/media/file-plus-02.9b1e6664001607e7e8a389d7f5a795f6.svg";
export { ForwardRef as ReactComponent };